import { renderingRule } from '../utils/markdown.plugin.utils.js';

/**
 * In order to make the <table> element keyboard accessible, ex the ability
 * to scroll left and right, we need to give it a tabindex.
 */
const Table = renderingRule('table_open', _ref => {
  let {
    origRender,
    tokens,
    idx
  } = _ref;
  tokens[idx].attrPush(['tabindex', '0']);
  return origRender();
});
var Table$1 = [Table];

export { Table, Table$1 as default };
